import {
  ContactFilters,
  ContactsResponce,
  NoticeEntity,
  NoticeFilters,
  NoticeResponce,
  NoticeResponceEntity,
} from "common/interfaces/notifications";
import { BaseApiService } from "./BaseApiService";

class NotificationsRepository extends BaseApiService {
  constructor() {
    super("notification");
  }

  fetchByFilter = async (filter: NoticeFilters) => {
    const sorting =
      filter.sorting === "notificationInfo/sendTime asc"
        ? "SortingBySendTime=Ascending&"
        : filter.sorting === "notificationInfo/sendTime desc"
        ? "SortingBySendTime=Descending&"
        : "";

    const status =
      filter.IsAwaiting === "await" ? "Pending" : filter.IsAwaiting === "history" ? "Sent" : "NotDelivered";

    const pageSize = filter.pageSize || 10;

    const res = await this.get<NoticeResponce>(
      `Notification/GetAll?${sorting}Pagination.Page=${filter.pagination}&Pagination.PageSize=${pageSize}&Status=${status}&Group=${filter.Group}&api-version=1.0`
    );

    return res;
  };

  fetchById = async (id: NoticeEntity["id"]) => {
    const res = await this.get(`Notification/Get?Id=${id}`);

    return res;
  };

  fetchByExternalId = async (externalId: NoticeResponceEntity["externalId"]) => {
    const res = await this.get(`Notification/Get?ExternalId=${externalId}`);

    return res;
  };

  fetchEmailsByFilter = async (filter: ContactFilters) => {
    const sorting =
      filter.sorting === "status asc"
        ? "SortingByStatus=Ascending&"
        : filter.sorting === "status desc"
        ? "SortingByStatus=Descending&"
        : "";
    const pageSize = filter.pageSize || 10;

    const res = await this.get<ContactsResponce>(
      `Notification/GetEmailRecipient?${sorting}Id=${filter.id}&Pagination.Page=${filter.pagination}&Pagination.PageSize=${pageSize}&api-version=1.0`
    );

    return res;
  };
  fetchPushesByFilter = async (filter: ContactFilters) => {
    const sorting =
      filter.sorting === "status asc"
        ? "SortingByStatus=Ascending&"
        : filter.sorting === "status desc"
        ? "SortingByStatus=Descending&"
        : "";

    const pageSize = filter.pageSize || 10;

    const res = await this.get<ContactsResponce>(
      `Notification/GetPushRecipient?${sorting}Id=${filter.id}&Pagination.Page=${filter.pagination}&Pagination.PageSize=${pageSize}&api-version=1.0`
    );

    return res;
  };

  publish = async (partner: Omit<NoticeEntity, "Id">) => await this.post("Notification/Push", JSON.stringify(partner));

  deleteById = async (id: NoticeEntity["id"]) => await this.delete(`Notification/Delete/${id}`);

  update = async (body: NoticeEntity) => await this.put(`Notification/Push`, JSON.stringify(body));

  getDeepLink = async () => await this.get("DeepLink/Get");

  // getSeasonForMvp = async () => await this.get("MvpVoting/getSeasonForMvp");

  addFile = async (file: File, fileContentType: string) => {
    const formData = new FormData();
    formData.append("file", file);

    return await this.post(`Notification/File?api-version=1.0`, formData, {
      headers: {},
    }).catch(() => "");
  };

  deleteFile = async (filePath: string) => {
    const fileName = filePath.split("/notifications/")[1];

    await this.delete(`Notification/File/${fileName}?api-version=1.0`);
  };

  uploadImg = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    return await this.post("Notification/Image?api-version=1.0", formData, {
      headers: {},
    }).catch(() => file.name);
  };

  removeImg = async (fileName: string) => {
    await this.delete(`Notification/Image/${fileName}`);
  };
}

export const notificationsRepository = new NotificationsRepository();
